<div class="important-information">
  <div class="w-full">
    <div class="w-full text-left">
      <h3>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 8V13M12 16H12.01M4.93726 16.4928C4.59135 16.1469 4.4184 15.974 4.29472 15.7721C4.18506 15.5932 4.10425 15.3981 4.05526 15.194C4 14.9638 4 14.7193 4 14.2301V9.76993C4 9.28075 4 9.03616 4.05526 8.80598C4.10425 8.60191 4.18506 8.40682 4.29472 8.22787C4.4184 8.02604 4.59135 7.85309 4.93726 7.50719L7.50719 4.93726C7.85309 4.59135 8.02604 4.4184 8.22787 4.29472C8.40682 4.18506 8.60191 4.10425 8.80598 4.05526C9.03616 4 9.28075 4 9.76993 4H14.2301C14.7193 4 14.9638 4 15.194 4.05526C15.3981 4.10425 15.5932 4.18506 15.7721 4.29472C15.974 4.4184 16.1469 4.59135 16.4928 4.93726L19.0627 7.50719C19.4086 7.85309 19.5816 8.02604 19.7053 8.22787C19.8149 8.40682 19.8957 8.60191 19.9447 8.80598C20 9.03616 20 9.28075 20 9.76993V14.2301C20 14.7193 20 14.9638 19.9447 15.194C19.8957 15.3981 19.8149 15.5932 19.7053 15.7721C19.5816 15.974 19.4086 16.1469 19.0627 16.4928L16.4928 19.0627C16.1469 19.4086 15.974 19.5816 15.7721 19.7053C15.5932 19.8149 15.3981 19.8957 15.194 19.9447C14.9638 20 14.7193 20 14.2301 20H9.76993C9.28075 20 9.03616 20 8.80598 19.9447C8.60191 19.8957 8.40682 19.8149 8.22787 19.7053C8.02604 19.5816 7.85309 19.4086 7.50719 19.0627L4.93726 16.4928Z"
            stroke="#3E68FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <strong>
          {{ title }}
        </strong>
      </h3>
    </div>
    <div class="w-full">
      <ng-content></ng-content>
      <button (click)="toggleMoreInfo()" class="link" *ngIf="hasMoreInfo">
        <span *ngIf="!isMoreInfoVisible" class="flex items-center">
          {{ 'transfers.common.more-info' | translate }}
          <svg-icon svgClass="w-[10px] h-[6px]" src="/assets/icons/arrow-info-down.svg"></svg-icon>
        </span>
        <span *ngIf="isMoreInfoVisible" class="flex items-center">
          {{ 'transfers.common.less-info' | translate }}
          <svg-icon svgClass="w-[10px] h-[6px]" src="/assets/icons/arrow-info-up.svg"></svg-icon>
        </span>
      </button>
    </div>
  </div>

  <div class="w-full" *ngIf="isMoreInfoVisible">
    <ng-content select="[moreInfo]"></ng-content>
  </div>
</div>
